/**
 * @desc - フォントの遅延読み込み
 * @link - https://firstlayout.net/use-noto-sans-japanese-fast/
 */

window.WebFontConfig = {
    custom: { families: [ 'Noto Serif CJK' ],
              urls: [ '/wp/wp-content/themes/no18/assets/font/noto/notoserif.css' ] },
    active: function() {
        sessionStorage.fonts = true;
    }
};
(function() {
    var wf = document.createElement('script');
    wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
    wf.type = 'text/javascript';
    wf.async = 'true';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(wf, s);
})();